import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevLogsStore } from '@argo/dev-logs';
import { 
  ScaModuleTitleComponent,
  ScaBadgeComponent,
  ScaAlertComponent,
  ScaIconComponent,
  ScaButtonComponent,
  ScaClaimCardComponent,
  ScaViewMoreComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-devlogs-test',
  standalone: true,
  imports: [
    CommonModule,
    ScaModuleTitleComponent,
    ScaBadgeComponent,
    ScaAlertComponent,
    ScaIconComponent,
    ScaButtonComponent,
    ScaClaimCardComponent,
    ScaViewMoreComponent
  ],
  template: `
    <div class="container">
      <sca-module-title class="title-test">
        <h1>DevLogs Playground</h1>
        <span scaModuleTitlePost>Sistema de desarrollo de logs - Testing @argo/dev-logs</span>
      </sca-module-title>

      <!-- Estado del Sistema -->
      <section class="card">
        <h2>Estado del Sistema</h2>
        
        <sca-alert variant="info" style="margin-bottom: 1.5rem;">
          <sca-icon icon="info" size="24px" [weight]="300" left />
          Control de logs desde Chrome Extension mediante window.postMessage
        </sca-alert>

        <div class="utilities-grid">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="bug_report" size="32px" />
            <span scaCardClaimTitle>Logs Generales</span>
            <span scaCardClaimDate>
              <sca-badge [variant]="devLogsStore.enabledLogs() ? 'success' : 'error'">
                {{ devLogsStore.enabledLogs() ? 'ACTIVOS' : 'DESACTIVADOS' }}
              </sca-badge>
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="navigation" size="32px" />
            <span scaCardClaimTitle>Logs Navegación</span>
            <span scaCardClaimDate>
              <sca-badge [variant]="devLogsStore.enabledNavigationLogs() ? 'success' : 'error'">
                {{ devLogsStore.enabledNavigationLogs() ? 'ACTIVOS' : 'DESACTIVADOS' }}
              </sca-badge>
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="touch_app" size="32px" />
            <span scaCardClaimTitle>Logs Acciones Usuario</span>
            <span scaCardClaimDate>
              <sca-badge [variant]="devLogsStore.enabledUserActionsLogs() ? 'success' : 'error'">
                {{ devLogsStore.enabledUserActionsLogs() ? 'ACTIVOS' : 'DESACTIVADOS' }}
              </sca-badge>
            </span>
          </sca-card-claim>
        </div>
      </section>

      <!-- Generar Logs -->
      <section class="card">
        <h2>Generar Logs de Prueba</h2>
        
        <sca-alert variant="warning" style="margin-bottom: 1.5rem;">
          <sca-icon icon="terminal" size="24px" [weight]="300" left />
          Los logs se imprimen en la consola del navegador. Abre DevTools (F12) para verlos
        </sca-alert>

        <div class="utilities-grid">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="bug_report" size="32px" />
            <span scaCardClaimTitle>DEBUG</span>
            <span scaCardClaimDate>
              Información detallada para desarrollo
              <br><br>
              <button sca-button variant="border" (click)="logDebug()">
                <sca-icon icon="bug_report" size="20px" left />
                Generar DEBUG
              </button>
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="info" size="32px" />
            <span scaCardClaimTitle>INFO</span>
            <span scaCardClaimDate>
              Información general del sistema
              <br><br>
              <button sca-button variant="border" (click)="logInfo()">
                <sca-icon icon="info" size="20px" left />
                Generar INFO
              </button>
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="warning" size="32px" />
            <span scaCardClaimTitle>WARN</span>
            <span scaCardClaimDate>
              Advertencia sobre situación anómala
              <br><br>
              <button sca-button variant="border" (click)="logWarn()">
                <sca-icon icon="warning" size="20px" left />
                Generar WARN
              </button>
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="error" size="32px" />
            <span scaCardClaimTitle>ERROR</span>
            <span scaCardClaimDate>
              Problema crítico detectado
              <br><br>
              <button sca-button variant="primary" (click)="logError()">
                <sca-icon icon="error" size="20px" left />
                Generar ERROR
              </button>
            </span>
          </sca-card-claim>
        </div>
      </section>

      <!-- API Documentation -->
      <section class="card">
        <h2>API del DevLogsStore</h2>
        
        <sca-alert variant="info" style="margin-bottom: 1.5rem;">
          <sca-icon icon="code" size="24px" [weight]="300" left />
          API completa del store de logs de desarrollo
        </sca-alert>

        <h3 style="margin-bottom: 1rem;">Método Principal</h3>
        <div style="margin-bottom: 2rem;">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="function" size="24px" />
            <span scaCardClaimTitle>devLogsStore.log()</span>
            <span scaCardClaimDate>
              <code>log(location: string, level: string, message: string, data?: any)</code>
              <br><br>
              Genera un log con formato coloreado en consola
            </span>
          </sca-card-claim>
        </div>

        <h3 style="margin-bottom: 1rem;">Signals Disponibles</h3>
        <div class="utilities-grid">
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="toggle_on" size="24px" />
            <span scaCardClaimTitle>enabledLogs()</span>
            <span scaCardClaimDate>
              <code>Signal&lt;boolean&gt;</code><br>
              Control de logs generales
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="toggle_on" size="24px" />
            <span scaCardClaimTitle>enabledNavigationLogs()</span>
            <span scaCardClaimDate>
              <code>Signal&lt;boolean&gt;</code><br>
              Control de logs de navegación
            </span>
          </sca-card-claim>
          
          <sca-card-claim>
            <sca-icon scaCardClaimIcon icon="toggle_on" size="24px" />
            <span scaCardClaimTitle>enabledUserActionsLogs()</span>
            <span scaCardClaimDate>
              <code>Signal&lt;boolean&gt;</code><br>
              Control de logs de acciones de usuario
            </span>
          </sca-card-claim>
        </div>

        <div style="margin-top: 2rem;">
          <sca-view-more [collapsedText]="'Ver Ejemplo de Uso'" [expandedText]="'Ocultar Ejemplo'" [isExpanded]="false">
            <pre class="code-example">{{ usageExample }}</pre>
          </sca-view-more>
        </div>
      </section>
    </div>
  `,
  styles: [`
    .container { 
      padding: 0 2rem;  
      margin: 0 auto; 
          @media (max-width: 1400px) {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    }
    
    .card { 
      background: white; 
      border-radius: 8px; 
      padding: 2rem; 
      margin-bottom: 2rem; 
      box-shadow: 0 2px 4px rgba(0,0,0,0.1); 
    }
    
    .card h2 { 
      color: #333; 
      margin-bottom: 1.5rem; 
      padding-bottom: 0.5rem; 
    }
    
    .card h3 {
      color: #555;
      font-size: 1.1rem;
      margin-top: 1.5rem;
    }
    
    .utilities-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 1.5rem;
      margin: 1rem 0;
    }
    
    code {
      background: #f5f5f5;
      padding: 0.2rem 0.5rem;
      border-radius: 4px;
      font-family: 'Courier New', monospace;
      font-size: 0.9rem;
    }
    
    pre.code-example {
      background: #263238;
      color: #aed581;
      padding: 0;
      border-radius: 8px;
      overflow-x: auto;
      line-height: 1.6;
      font-family: 'Courier New', monospace;
      margin: 0;
    }
    
    .title-test {
      margin-bottom: 2rem;
    }
  `]
})
export class DevLogsTestComponent {
  readonly devLogsStore = inject(DevLogsStore);
  
  readonly usageExample = `// Inyectar el store
readonly devLogsStore = inject(DevLogsStore);

// Generar logs
devLogsStore.log('ComponentName', 'DEBUG', 'Mensaje de debug');
devLogsStore.log('ComponentName', 'INFO', 'Información general');
devLogsStore.log('ComponentName', 'WARN', 'Advertencia');
devLogsStore.log('ComponentName', 'ERROR', 'Error crítico', { error: 'details' });

// Leer estado de logs
const logsActivos = devLogsStore.enabledLogs();
const navLogsActivos = devLogsStore.enabledNavigationLogs();
const userActionsActivos = devLogsStore.enabledUserActionsLogs();`;

  logDebug(): void {
    this.devLogsStore.log('DevLogsTest', 'DEBUG', 'Log de DEBUG - información detallada para desarrollo');
  }

  logInfo(): void {
    this.devLogsStore.log('DevLogsTest', 'INFO', 'Log de INFO - información general del sistema');
  }

  logWarn(): void {
    this.devLogsStore.log('DevLogsTest', 'WARN', 'Log de WARN - advertencia sobre situación anómala');
  }

  logError(): void {
    this.devLogsStore.log('DevLogsTest', 'ERROR', 'Log de ERROR - problema crítico detectado', {
      error: 'test-error',
      code: 500
    });
  }
}
